export const SIDE_PANEL_WIDTH = '550px';
export const THREAD_FLOW_TOP_MARGIN = '50px';
export const THREAD_CANVAS_WIDTH = 800;
export const THREAD_MODULE_CONTAINER_WIDTH = 500;
export const THREAD_CANVAS_BOTTOM_MARGIN = 16;

export const ADD_SUB_ACTION_LABEL = 'Add Sub-Action';
export const HIDE_SUB_ACTION_LABEL = 'Hide Sub-Action';
export const SHOW_SUB_ACTION_LABEL = 'Show Sub-Action';
